module.exports = __webpack_public_path__ + "./config/videotron-dev.json";